import type { LoginTokenDataObject } from './service';

export type LoginToken = {
  loginToken: string;
};

export type Oauth = {
  accessToken: string;
  createdAt: number;
  expiresIn: number;
  refreshToken: string;
};

export const createLoginToken = (data: LoginTokenDataObject): LoginToken => ({
  loginToken: data.login_token,
});
